import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import {
  AfterViewInit,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ProjectStagesComponent } from '../project-stages.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ChangeDetectorRef } from '@angular/core';
@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ProjectStagesComponent,
  ],
  selector: 'app-project-wrapper',
  templateUrl: './project-wrapper.component.html',
  styleUrls: ['./project-wrapper.component.css'],
})
export class ProjectWrapperComponent implements AfterViewInit {
  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;
  constructor(
    public dialog: MatDialog,
    private tenderingService: TenderingService,
    private cdr: ChangeDetectorRef
  ) {}
  ngAfterViewInit(): void {
    this.openDialog();
  }

  openDialog(): void {
    this.dialog.open(this.dialogTemplate, {
      width: '89vw',
      height: 'fit-content',
      maxHeight: '90vh',
      disableClose: true,
      autoFocus: false,
    });
  }
}
